import { TabsContent } from '@/components/ui/tabs';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { useAuditoria } from '@/services/Configuracoes';

export function AuditoriaTab() {
  const { data: response, isLoading } = useAuditoria();
  const logs = response?.data ?? [];

  return (
    <TabsContent value="auditoria" className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Logs de Auditoria</CardTitle>
        </CardHeader>
        <CardContent>
          {isLoading ? (
            <div className="space-y-3">
              {[1, 2, 3, 4].map(i => (
                <Skeleton key={i} className="h-10 w-full" />
              ))}
            </div>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead className="w-40">Data / Hora</TableHead>
                  <TableHead>Usuário</TableHead>
                  <TableHead>Ação</TableHead>
                  <TableHead>Detalhes</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {logs.length === 0 ? (
                  <TableRow>
                    <TableCell
                      colSpan={4}
                      className="text-center py-8 text-muted-foreground text-sm"
                    >
                      Nenhum log encontrado
                    </TableCell>
                  </TableRow>
                ) : (
                  logs.map(log => (
                    <TableRow key={log.ID}>
                      <TableCell className="text-sm text-muted-foreground whitespace-nowrap">
                        {log.DataHora}
                      </TableCell>
                      <TableCell className="text-sm">{log.Usuario}</TableCell>
                      <TableCell className="text-sm font-medium">{log.Acao}</TableCell>
                      <TableCell className="text-sm text-muted-foreground">
                        {log.Detalhes}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>
    </TabsContent>
  );
}
